import { format } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_ENDPOINT } from '../../../../urls';
import { editModeOn, filterLetters, getFromDecreaptLocalStorage, scrollToTop, viewModeOn } from '../../../../utilFunctions';
import NoDataFound from '../../../../utilsComponent/noDataFound';
import LoadingPage from '../../../../reusableComponents/loader/loadingPage';
import { functionalities } from '../../../../consts';
import { axiosRequest } from '../../../../service';
import DocumentSliderModal from '../../../../utilsComponent/DocumentSliderModal';
import { getClaimDocuments } from '../../../apiHelper';
import TabComponent from '../../../../reusableComponents/tab/TabComponent';
import PolicyDocumentsSection from '../../../documentsIAGRI/PolicyDocumentsSection';
import { loadPolicyDocumentsData } from '../../../documentsIAGRI/documentFetchHelpers'
import { useLocation } from 'react-router-dom';
import { fetchDocumentTypes } from '../../ClaimIntimation/ClaimForm/apiHelper';
import "./healthDocuments.scss"
import { loadHospiPolicyDocumentsData } from '../../../documentsIAGRI/apiHelper';

const HealthDocuments = (props) => {
    const location = useLocation();
    const { policyDetailCookie, claimDetails } = props;
    const { loading, setLoading } = useState(false)
    const [file, setFile] = useState([]);
    const [isFileLoading, setIsFileLoading] = useState(false)
    const [selectedDocument, setSelectedDocument] = useState("")
    const [addedFiles, setAddedFiles] = useState([])
    const [fileSize, setfileSize] = useState(0);
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    const [formDataForAPi, setFormDataForAPi] = useState(null)
    const [fileInputAPi, setFileInputApi] = useState(null)
    const [uploadedDocumentsList, setUploadedDocumentsList] = useState([])
    const [showSliderModal, setShowSliderModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(false);
    const ignoreFileKeys = ['PreRegRuleLog', 'PostRegRuleLog', 'Rejection Letter', 'CWP Letter', 'Rejection Letter', 'Payout Letter', 'rejection', 'repudiation', 'payment']; // there are system generated json files
    const [activeTab, setActiveTab] = useState(() => {
        return location.state?.activeTab || 'documents';
    });
    const [policyDocuments, setPolicyDocuments] = useState([]);
    const [isLoadingPolicyDocuments, setIsLoadingPolicyDocuments] = useState(false);
    const [showPolicyDocSliderModal, setShowPolicyDocSliderModal] = useState(false);
    const [currentPolicyDocSlideIndex, setCurrentPolicyDocSliderIndex] = useState(0);
    const [dragActive, setDragActive] = useState(false);
    const [documentTypes, setDocumentTypes] = useState([]);

    const getDocumentTypes = async () => {
        setIsFileLoading(true)
        const response = await fetchDocumentTypes();
        setDocumentTypes(response)
        setIsFileLoading(false)
    }

    useEffect(() => {
        if (activeTab === 'policyDocuments') {
            scrollToTop();
        }
    }, [activeTab]);

    useEffect(() => {
        getDocumentTypes();
    }, [])

    useEffect(() => {
        if (policyDetailCookie) {
            // The isLoading state is now managed entirely within the loadPolicyDocumentsData function
            // and doesn't need to be in the dependency array.
            loadHospiPolicyDocumentsData(
                policyDetailCookie,
                setIsLoadingPolicyDocuments,
                setPolicyDocuments
            );
        }
    }, [policyDetailCookie]);

    // Function to open the slider for policy documents
    const openPolicyDocSlider = useCallback((index) => {
        setCurrentPolicyDocSliderIndex(index);
        setShowPolicyDocSliderModal(true);
    }, []);

    // Memoize the getUploadedDocumentsList function using useCallback
    const getUploadedDocumentsList = useCallback(async () => {
        const data = await getClaimDocuments(claimDetails.claimId, true);
        if (data?.data) {
            setUploadedDocumentsList(filterLetters(data.data, false))
        }
        return data?.data
    }, [claimDetails.claimId]);

    // This useEffect will only run on mount and when claimNo changes.
    // It handles fetching uploaded documents.
    useEffect(() => {
        getUploadedDocumentsList();
    }, [getUploadedDocumentsList]);



    // Handles the deletion of a file from the list of files.
    const handleDeleteFile = (index) => {
        const updatedFiles = [...file];
        // Removes selected file from the list 
        updatedFiles.splice(index, 1);
        setFile(updatedFiles);
        let newFileSize = 0;
        let formData = new FormData();
        // Calculate the size of each file in megabytes (MB) and add it to the total file size.
        updatedFiles.forEach(file => {
            const fileSizeMB = Number((file.size / (1024 * 1024)).toFixed(4));
            newFileSize += fileSizeMB;
            formData.append('files', file);
        });
        setfileSize(newFileSize);
        setFormDataForAPi(formData);
        setAddedFiles(updatedFiles.map(file => ({ name: file.name })));
    };
    const handleRejectClick = () => {
        setFile([])
        setShowRejectPopover(!showRejectPopover);
    };

    const [showRejectPopover, setShowRejectPopover] = useState(false);

    const handleDragEnter = () => {
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragActive(false);
        const fileData = event.dataTransfer.files[0];
        file.push(fileData)
        setFile([...file]);
    };

    const handleFileChange = (event) => {
        if (isFileLoading) {
            return
        }
        const fileInput = document.getElementById('fileInput');
        setFileInputApi(fileInput)
        if (!fileInput) {
            setIsFileLoading(false);
            return;
        }
        const newFiles = Array.from(fileInput.files);
        const updatedFiles = [...file, ...newFiles];
        setFile(updatedFiles);
        let newFileSize = fileSize;
        // Ensure formDataForAPi is initialized
        let formData = formDataForAPi || new FormData();

        for (let i = 0; i < newFiles.length; i++) {
            const fileType = newFiles[i].type;
            const fileSizeMB = Number((newFiles[i].size / (1024 * 1024)).toFixed(4));

            if ((fileSizeMB + newFileSize) > 50) {
                toast.error("File Size Should be Less Than 50MB.");
                return;
            }
            if (['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'application/pdf'].includes(fileType)) {
                newFileSize += fileSizeMB;
                formData.append('files', newFiles[i]);
                setAddedFiles(prevFiles => [...prevFiles, { name: newFiles[i].name }]);
            } else {
                toast.error("File should be in the selected format.")
                setIsFileLoading(false)
                fileInput.value = ""; // Clear the file input
                return
            }
        }

        setfileSize(newFileSize);
        setFormDataForAPi(formData);
        setIsFileLoading(false);
    }

    const handleSubmit = () => {
        if (!selectedDocument?.value) {
            toast.error("Please Select Document Name.")
            return
        }
        if (addedFiles.length === 0) {
            toast.error("Please Select Document.")
            return
        }
        const prevDocuments = uploadedDocumentsList
        setIsFileLoading(true);
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/health/cp/upload/bulk?userId=${String(roleDataCookie?.userID)}&docName=${selectedDocument?.label}&docType=${selectedDocument?.value}&claimId=${claimDetails.claimId}&source=CMS`, formDataForAPi).then(async data => {
            toast.success(data.data)
            setIsFileLoading(false);
            setFile([]);
            setfileSize(0);
            setFormDataForAPi(null);
            setAddedFiles([]);
            await getUploadedDocumentsList()
        }).catch(error => {
            console.error(error)
            toast.error("Something Went Wrong. ")
        }).finally(() => {
            setIsFileLoading(false);
            fileInputAPi.value = "";
            setFileInputApi(null)
            setSelectedDocument("")
            handleRejectClick()
        });
    };

    const onDocUrlClick = (index) => {
        setShowSliderModal(true);
        setCurrentIndex(index)
    }

    const tabs = [
        { key: 'documents', label: 'Documents', page: functionalities.DOCUMENTS_PAGE },
        { key: 'policyDocuments', label: 'Policy Documents', page: functionalities.DOCUMENTS_PAGE },
    ];

    const filteredTabs = tabs.filter(tab => viewModeOn(tab.page));

    const handleTabClick = (tabKey) => {
        setActiveTab(tabKey);
    };

    return (
        <>
            {loading && <LoadingPage kshemaLoader/>}
            <div className='mt-3 claim-processing-tabs bg-white rounded'>
                <div className='d-flex w-50'>
                    <TabComponent
                        tabs={filteredTabs}
                        activeTab={activeTab}
                        handleTabClick={handleTabClick}
                    />
                </div>
                <div className='d-flex flex-column'>
                    {activeTab === 'documents' && (
                        <>
                            <div className='d-flex justify-content-end w-60'>
                                {editModeOn(functionalities.DOCUMENTS_UPLOAD) && <button className={'btn btn-success mt-4 mb-4 me-4 px-4'} onClick={() => { setAddedFiles([]); setSelectedDocument(""); setShowRejectPopover(!showRejectPopover) }}>Upload</button>}
                                <Modal show={showRejectPopover} isOpen={showRejectPopover} toggle={handleRejectClick} centered={true} backdrop={'static'}>
                                    <ModalHeader>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleRejectClick} ></button>
                                    </ModalHeader>
                                    <ModalBody>
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group mb-3">
                                                <label >Select Document Name <span className='text-danger'>*</span></label>
                                                <Select
                                                    options={documentTypes}
                                                    placeholder="Select Document Name"
                                                    value={selectedDocument}
                                                    onChange={(data) => { setSelectedDocument(data); }}
                                                />
                                                <label htmlFor="fileInput" className='mt-3'>Upload Documents <span className='text-danger'>*</span></label>
                                                <div
                                                    className="drop-zone drag-zone-upload"
                                                    onDragEnter={handleDragEnter}
                                                    onDragOver={handleDragOver}
                                                    onDragLeave={handleDragLeave}
                                                    onDrop={handleDrop}
                                                >
                                                    {isFileLoading ? (
                                                        <LoadingPage />
                                                    ) : (
                                                        <>
                                                            <label htmlFor="fileInput" className="drop-zone__prompt pointer">Drop file here or click to upload</label>
                                                            <input
                                                                type="file"
                                                                name="fileInput"
                                                                id="fileInput"
                                                                className="drop-zone__input d-none"
                                                                accept=".pdf, .jpg, .jpeg, .png, .gif"
                                                                onChange={() => handleFileChange()}
                                                                onClick={(event) => event.target.value = ""}
                                                                multiple
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                                {addedFiles.map((file, index) => (
                                                    <div className="align_4_dataPolicy deletePolicy mt-2" key={file.id}>
                                                        <span className="hoverPolicy file-name">{file.name}</span>
                                                        <span className="marginPolicy hoverPolicy" onClick={() => { handleDeleteFile(index) }}>
                                                            <img
                                                                src="/kshemaImages/delete_symbol.png"
                                                                alt="delete"
                                                                height="18px"
                                                                width="auto"
                                                            />
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </form>
                                    </ModalBody>
                                    <ModalFooter className='footer-container'>
                                        <Button variant='outline-danger' onClick={handleRejectClick}>Cancel</Button>
                                        <Button variant='outline-success' onClick={() => handleSubmit()}>Submit</Button>
                                    </ModalFooter>
                                </Modal>
                            </div>
                            {uploadedDocumentsList && uploadedDocumentsList.length > 0 ? (
                                <div className='documents-div'>
                                    <table className='documents-table'>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Uploaded Date</th>
                                                <th>Uploaded By</th>
                                                <th>Documents</th>
                                                <th>Source</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {uploadedDocumentsList.map((doc, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{doc.createdDate ? format(new Date(doc.createdDate.split(".")[0]), 'dd-MM-yyyy, hh:mm a') : "-"}</td>
                                                    <td>{doc.createdBy || "-"}</td>
                                                    <td onClick={() => { onDocUrlClick(index) }} className='pointer text-primary'>{doc.docName}</td>
                                                    <td>{doc.source || "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : <NoDataFound text="No Data Found" />}
                        </>


                    )}
                    {showSliderModal && (
                        <DocumentSliderModal
                            currentIndex={currentIndex}
                            setCurrentIndex={setCurrentIndex}
                            onClose={() => { setShowSliderModal(false) }}
                            documents={uploadedDocumentsList}
                            show={showSliderModal}
                        />
                    )}
                    {activeTab === 'policyDocuments' && (
                        <PolicyDocumentsSection
                            documents={policyDocuments}
                            isLoadingDocuments={isLoadingPolicyDocuments}
                            openDocumentSlider={openPolicyDocSlider}
                            isSliderOpen={showPolicyDocSliderModal}
                            currentSlideIndex={currentPolicyDocSlideIndex}
                            setCurrentSlideIndex={setCurrentPolicyDocSliderIndex}
                            onSliderClose={() => setShowPolicyDocSliderModal(false)}
                        />
                    )}
                </div>
            </div >
        </>
    )
}
export default HealthDocuments;